module.exports = __webpack_public_path__ + "static/img/5286_phase_function_Paper_PointsHejduk_Prediction.53cc16d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/5286_phase_function_Paper_PointsHejduk_Prediction.png
// module id = QRsT
// module chunks = 0